import { EEarningStatuses } from 'store/fetchers/earnings/enum'

interface FilterItem {
  id: string
  title: string
  statuses?: EEarningStatuses[]
}

export enum EarnStatus {
  AllSavings = 'allSavings',
  Active = 'active',
  Closed = 'closed',
}

export const filterItems: Record<EarnStatus, FilterItem> = {
  [EarnStatus.AllSavings]: { id: EarnStatus.AllSavings, title: 'All savings', statuses: [] },
  [EarnStatus.Active]: {
    id: EarnStatus.Active,
    title: 'Active',
    statuses: [EEarningStatuses.ACTIVE, EEarningStatuses.CHARGING],
  },
  [EarnStatus.Closed]: {
    id: EarnStatus.Closed,
    title: 'Closed',
    statuses: [EEarningStatuses.CLOSED],
  },
}
